var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabelWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 50,
    rx: 5,
    fill: "#2a2a2a",
    stroke: "#444"
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 30,
    textAnchor: "middle",
    fill: "#eee",
    fontFamily: "monospace",
    fontSize: 14
  }, "Value"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelWidget);
export default __webpack_public_path__ + "static/media/label-widget.2125f28470e09b7a23ccf1707ffee9c1.svg";
export { ForwardRef as ReactComponent };